import React from 'react'
import PropTypes from 'prop-types'
import FooterColumn from './FooterColumn'
import FooterLegal from './FooterLegal'
import FooterLogo from './FooterLogo'
import FooterWrapper from './FooterWrapper'

const FooterExternal = ({ footer, version }) => {
  const { items, logo } = footer
  return (
    <FooterWrapper version={version}>
      <div className="row component-row-style">
        <FooterColumn items={items} itemKey="columncontrol" version={version} />
      </div>
      <div className="row component-row-style columncontrolmobile">
        <FooterColumn
          isNested
          items={items}
          version={version}
          itemKey="columncontrolmobile"
        />
      </div>
      <FooterLegal text={items.rte.text} version={version} />
      <FooterLogo logo={logo} version={version} />
    </FooterWrapper>
  )
}

FooterExternal.propTypes = {
  footer: PropTypes.object.isRequired,
  version: PropTypes.string.isRequired
}

export default FooterExternal



// WEBPACK FOOTER //
// ./src/components/Footer/FooterExternal.js